<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <div>
          Sentiment:
        </div>

        <font-awesome-icon
          icon="smile"
          class="ml-2 my-auto pointer f-size-20 text-success"
        />
        <font-awesome-icon
          icon="angry"
          class="ml-1 my-auto  pointer f-size-20 text-danger"
        />
      </div>
      <div class="d-flex">
        <div>
          Channel:
        </div>

        <div class="d-flex">
          <div v-for="(item, index) in data.channel" :key="index">
            <template v-if="item == 1">
              <font-awesome-icon
                :icon="['fab', 'line']"
                class="ml-2 my-auto pointer f-size-20 line-color"
              />
            </template>
            <template v-if="item == 2">
              <font-awesome-icon
                icon="mobile-alt"
                class="ml-2 my-auto pointer f-size-20 "
              />
            </template>
            <template v-if="item == 3">
              <font-awesome-icon
                icon="window-maximize"
                class="ml-2 pointer my-auto  f-size-20"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Object
    },
    channelList: {
      required: true,
      type: Array
    }
  }
};
</script>

<style lang="scss" scoped>
.f-size-20 {
  font-size: 20px;
}
.line-color {
  color: #00b900;
}
</style>
